/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "ap-south-1",
    "aws_cloud_logic_custom": [
        {
            "name": "api",
            "endpoint": "https://u8odzpyoz4.execute-api.ap-south-1.amazonaws.com/prod",
            "region": "ap-south-1"
        }
    ],
    "aws_appsync_graphqlEndpoint": "https://rpddnyg45reilmlbh6trkcw4ua.appsync-api.ap-south-1.amazonaws.com/graphql",
    "aws_appsync_region": "ap-south-1",
    "aws_appsync_authenticationType": "API_KEY",
    "aws_appsync_apiKey": "da2-33ktt4vyqbgwvi5jdvkhdsmkmq",
    "aws_cognito_identity_pool_id": "ap-south-1:7f59464d-435a-4529-8d27-886c68ff4768",
    "aws_cognito_region": "ap-south-1",
    "aws_user_pools_id": "ap-south-1_ZIENhqUXa",
    "aws_user_pools_web_client_id": "79v7mshd3ga7lhbar46ue1mm96",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [],
    "aws_cognito_mfa_configuration": "ON",
    "aws_cognito_mfa_types": [
        "SMS",
        "TOTP"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": [
            "REQUIRES_LOWERCASE",
            "REQUIRES_UPPERCASE",
            "REQUIRES_NUMBERS",
            "REQUIRES_SYMBOLS"
        ]
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_user_files_s3_bucket": "bgr-storage143049-prod",
    "aws_user_files_s3_bucket_region": "ap-south-1"
};


export default awsmobile;
